import { useTranslation } from "react-i18next";
import { MainContentPaddingTypes, NewButton, NewInput, NewModal } from "../../BaseComponents"
import { FeedCurve } from "../../../Services";
import { RefObject, useState } from "react";
import { NewInputHandles } from "../../../Definitions";

interface NewFeedcurveProps {
  handleClose: () => void;
  copyFeedcurve?: FeedCurve;
  handleCreateFeedCurve: (feedCurveName: string, copyFeedcurve?: FeedCurve) => void;
  feedCurveNameInputRef: RefObject<NewInputHandles>;
}

export default function NewFeedcurve({ handleClose, handleCreateFeedCurve, feedCurveNameInputRef, copyFeedcurve }: NewFeedcurveProps) {
  const { t } = useTranslation();
  const [error, setError] = useState<string>("");

  const handleCreateClick = () => {
    const inputEl = feedCurveNameInputRef.current;
    const name = (inputEl && typeof inputEl.value === "string") ? inputEl.value : "";

    if (!name) {
      setError(t("feedCurvePages.feedCurves.feedCurveNameMissing", {defaultValue: "feed curve name missing"}));
      setTimeout(() => setError(""), 2000);
      return;
    }
    
    handleCreateFeedCurve(name, copyFeedcurve);
  };

  return (
    <NewModal
      overrides={{
        mainContentPadding: MainContentPaddingTypes.secondary,
      }}
      predefinedButtons={{
        onClose: handleClose
      }}
      header={t("feedCurvePages.feedCurves.newFeedCurve", {defaultValue: "New Feed Curve"})}
      subHeader={copyFeedcurve !== undefined ? `${t("feedCurvePages.feedCurves.fromFeedCurve", {defaultValue: "From Feed Curve"})} ${copyFeedcurve.feedCurveId}: ${copyFeedcurve.name}` : "" }
      mainContent={
        <NewInput
          ref={feedCurveNameInputRef}
          header={t("feedCurvePages.feedCurves.feedCurveName", { defaultValue: "Feed Curve Name" })}
          valueOverrides={{ valueType: "string" }}
          isRequired
        />
      }
      footerContent={
        <NewButton
          content={t("feedCurvePages.feedCurves.createFeedCurve", {defaultValue: "Create Feed Curve"})}
          onClick={handleCreateClick}
          overrides={{
            baseStyles: {width: "fit-content"}
          }}
        />
      }
      footerMessage={error}
    />
  )
}